var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJasminetrip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.9 421.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b2b1b2;\n        stroke: #b2b1b2;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #545554;\n      }\n\n      .cls-2, .cls-3, .cls-4 {\n        stroke: #535453;\n      }\n\n      .cls-3 {\n        fill: #b3b1b2;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #555;\n        stroke: #555;\n      }\n\n      .cls-6 {\n        fill: #e9e9e9;\n        stroke: #e9e9e9;\n      }\n\n      .cls-7 {\n        fill: #717272;\n        stroke: #717272;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eyes"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 66.76,
    y: 98.6,
    width: 119.06,
    height: 44.95
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Color_Mirror",
    "data-name": "Color Mirror"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.26,280.45l-5.49-29.42-8.86-4.48,4.37-17.05-6.23-17.77-14.34,9.25,4.93-9.64-14.46,7.06,6.78-21.51-4.71-7.17,2.47-18.95,9.19-16.24-2.24-12.46-11.77-12.22-7.4-7.43,7.17-17.44-1.12-8.88-4.6-7.62.34-24.38-15.47-11.15-11.44-4.6s-10.76-17.15-14.35-18.05c-3.59-.9-24.66-7.29-31.5-7.4-6.84-.11-34.87,6.39-39.35,8.41-4.48,2.02-22.65,21.19-22.65,21.19l-17.44,33.8-3.07.17,1.91,7.06s-6.17,5.27-5.04,8.52c1.12,3.25,7.6,15.51,6.21,22.98l-18.59,16.32.49,13.93,5.07,12.39,4.31,11.8-1.29,11.91-4.35,7.33-20.39-1.8c-4.16-6.94-3.33-9.82-1.49-17.29-13.89,14.81-10.43,21.64-2.75,26.53l6.57,3.45-3.56,19.91,4.42,16.32-9.47,6.51-4.33,32.28,5.93,60.6,8.94,64,191.56,3.93,12.89-33.52,5.04-17.6,3.3-2.58-3.18-3.83,3.18-6.8,5.67-1.25,4.15-13.68-5.25-3.83,3.39-7.06,3.77,1.14,1.25-9.35-3.15-2.42,6.05-31.9-.02-.02ZM111.48,128.03s-6.66,5.38-17.07,3.83c-12.87-1.91-13.03-14.79-13.03-14.79,0,0,11.26-5.63,13.94-5.63s18.66,9.3,18.66,9.3l-2.49,7.28h-.01ZM158.08,130.58c-10.34,2.02-19.91-2.42-19.91-2.42l-2.4-7.99s15.25-9.17,17.94-9.17,15.72,6.14,15.72,6.14c0,0-1.01,11.42-11.35,13.44Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.89,305.15s3.69-6.18,3.14-11.28-3.04-27.33-5.64-29.28-6.61-5.05-6.51-6.81c0,0,4.5.73,6.1.74s12.02,5.2,12.02,5.2l4.2,36.22-13.32,5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.03,254.62s3.62-3.5,1.22-6.38c-2.39-2.88-22.98,1.54-22.98,1.54,0,0-12.54,2.16-14.01,4.85-1.47,2.69-1.99,2.69-1.99,2.69,0,0,.24-4.69,5.17-9.4,0,0,19.04-6.24,19.15-10.29s-7.08-12.69-7.08-12.69l10.25-10.29,21.78,22.76-3.9,13.39-7.61,3.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.52,295.85c5.05-1.48-.2-4.79-1.63-4.79,0,0-3.73,4.67-6.75,4.59s0,11.07,0,11.07c0,0,4.59-9.76,8.37-10.87h.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.41,305.15s-3.69-6.18-3.14-11.28,3.04-27.33,5.64-29.28,6.61-5.05,6.51-6.81c0,0-4.5.73-6.1.74s-12.02,5.2-12.02,5.2l-4.2,36.22,13.32,5.2h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M78.28,254.62s-3.62-3.5-1.22-6.38,22.98,1.54,22.98,1.54c0,0,12.54,2.16,14.01,4.85,1.47,2.69,1.99,2.69,1.99,2.69,0,0-.24-4.69-5.17-9.4,0,0-19.04-6.24-19.15-10.29s7.08-12.69,7.08-12.69l-10.25-10.29-21.78,22.76,3.9,13.39,7.61,3.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.78,295.85c-5.05-1.48.2-4.79,1.63-4.79,0,0,3.73,4.67,6.75,4.59s0,11.07,0,11.07c0,0-4.59-9.76-8.37-10.87h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.8,245.82l6.01-19.38-7.52-13.55s-7.24-11.4-7.65-13.77,14.72-20.3,24.62-10.11c9.9,10.19,7.14,14.69,7.14,14.69,0,0,2.47-28.2-13.61-27.97s-23.98,2.16-23.98,2.16l-3.29-3.19,6.75-20.17s-2.25-17.44-6.83-21.19-12.45-9.84-12.45-9.84c0,0,2.97-12.64,6.1-17.09s-4.45-15-4.45-15l.7-9.06-3.96-20.09-21.4-11.43-6.03-10.35s-17.59-18.6-10.01-27.51c9.44-11.1,19.63-1.84,19.63-1.84,0,0-11.56-11.47-23.03-6.14-9.14,4.25-7.97,20.86-10.07,20.47-9.13-1.68-20.2-2.44-26.61-1.68-9.67,1.14-41.47,6.26-49.83,19.52-8.36,13.27-21.99,44.14-21.99,44.14-5.79-6.69-6.43-17.77-7.51-28.47l-4.38,16.33,4.18,21.03,7.88,23.93-3.6,7.29s-17.96,13.97-17.99,19.76,15.3,28.54,11.24,40.83c0,0,5.35-2.17,4.76-13.92s-1.39-18.74.05-18.89,11.31,11.86,13.26,16.06c2.5,5.39,3.65,16.35,3.65,16.35,1.58-.24,5.2-2.48,5.2-12.46s6.25,5.04,6.55,8.01,3.6,19.69-6.68,30.59c-8.38,8.89-11.47,12.06-13.24,16.92-.69,1.9-2.96,2.68-4.68,1.61-2.64-1.66-6.04-4.18-7.67-7.04-3.12-5.46-1.19-15.47-1.19-15.47l-14.54,1.63-8.81,1.64-3.87,15.09,3.87,14.65.17,3.63-8.35,6.19-6.8,31.41,2.76,14.27s.46-13.11,4.63-21.88c4.16-8.77,7.14-11.45,12.79-11.45s11.87.72,13.98,7.27c2.11,6.54,1.6,32.49,3.39,43.05s12.19,85.49,11.52,89.39l9.88,4.42s-3.47-29.71-5.48-41.41c-1.37-7.96-1.31-17.02-1.31-17.02l-3.32-30.12,1.72-19.25,11.96-2.99,1.77-36.1s13.52-5.28,15.01-6.06c0,0-14.09-5.08-14.9-8.78s2.89-20.8,2.89-20.8c0,0,2.66,12.04,8.03,12.95,5.37.91,8.14,1.37,8.14,1.37,0,0-6.59-5.31-6.35-7.51s16.75-15.13,16.75-15.13l4.27-12.02s19.37,20.1,25.51,19.87c6.15-.23,14.81-3.7,18.51-8.55,0,0-1.5,8.96.81,10.6s10.28,5.8,10.28,5.8l-1.95-13.24,4.36-.92s13.71,9.93,13.71,12.61-6.56,8.08-6.56,8.08c0,0,3.49,1.71,8.45-.97,4.96-2.68,9.25-9.47,9.25-9.47l2.25,15.65-7.25,9.88-6.71-.63,8.14,6.2,10.34,2.7,2.42,33.75,6.34,3.99,1.62-22.21,6.03-8.77s7.3-.82,12.33-4.12c5.04-3.3,8.17-6.07,10.15-4.1,1.98,1.96,7.75,8.22,5.52,21.9s-19.41,115-19.41,115l17.92,12.78,10.67-99.02,4.75-31.56-4.75-29.99-10.58-5.78h-.02ZM179.69,116.49l-10.9,13.11-1.56,11.94,7.32,11.51-10.97,20.84-21.06,20.63-15.09,9.66-9.34-2.17-29.61-22.55-7.16-12.89-6.66-14.68s6.74-11.78,6.9-15.36c.15-3.58-2.33-9.75-4.71-12.55-2.39-2.8-7.11-13.19-7.11-13.19l19.22-.96,11.34-6.72,11.83-22.15,19.11-9.75,13.13,2.08,9.99,6.81,10.81.26,10.66,7.62,5.44,8.32-1.57,20.19h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M81.76,117.59s5.3,11.9,4.23,19.39c-.51,3.62-.24,10.34-.02,17.87.15,5.11,18.09-5.95,18.1-12.42,1.4,15.95-16.98,23.82-15.82,24.92.87.83,2.69,10.08,4.72,13.42l-12.66-18.9-5.67-9.96,6.9-15.36-11.82-25.74,39.98-45.8,55.06,5.5,21.29,25.08-9.76,53.1s-11.71,25.25-14.37,27.74-32.24,27.55-34.51,27.78-4.53-1.05-4.53-1.05c0,0,9.65-7.96,10.91-17.34,3.76-1.9,8.69-8.04,6.1-9.65l.7-.19s9-11.97,9.41-15.55c.13-1.16-5.77-13.55-5.22-16.84.28-1.66,6.91,6.17,7.23,4.4,1-5.6,2.07-11.07,2.49-11.86.82-1.53,14.63-14.77,14.07-18.15,0,0-4.91-2-4.91-5.12s-.52-6.77-.52-6.77l2.93-1.52s1.28-14.58-1.59-17.55-18.11-5.11-23.88-2.09c-4.62,2.42-16.33,10.24-19.76,19.06s7.75,19.62,7.3,19.73c-1.08.25-16.63-6.34-18.97-6.82-2.47-.51-7.37-2.95-10.79-3.28-6.64-.65-16.62,3.99-16.62,3.99v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.07,101.31s-5.23,16.32-5.33,19.21,2.02,30.21,1.06,33.1-2.57,4.8-2.57,4.8l9.69-2.78-3.41-35.87,10.97-6s-1.45-1.6,0-4.26,1.84-4.3,1.84-4.3l-12.25-3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.94,296.66s-1.59,3.64,0,10.05,2.66,11.43,2.66,11.43l-10.45.27s1.5-11.64,2.66-14.44,5.12-7.32,5.12-7.32h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M60.47,300.7l7.82,42.68,100,4.51,20.03-22.7-1.65-25.25s-38.79,22.13-61.52,20.09-64.68-19.33-64.68-19.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M125.15,330.09c-6.16,3.71-26.16,16.9-45.59,9.35s-16.05-24.9-15.47-39.5c0,0-5.47-1.54-9.52,2.02s5.9,114.14,5.9,114.14l40.79,3.23,35.79-4.84-12.72-62.28.83-22.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M137.05,414.49l-29.35-6.94,17.9-77.46h0c6.16,3.71,26.16,16.9,45.59,9.35s16.05-24.9,15.47-39.5c0,0,5.47-1.54,9.52,2.02s1.35,26.69,1.35,26.69l-7.27,84.41-53.22,1.42Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "125.15 283.19 120.96 291.06 124.79 293.92 129.28 289.77 125.15 283.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M121.12,288.39s2.83,1.27,3.28,1.23l-.74-5.34-2.54,4.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M105.52,180.66l5.85-7.57s9.94,3.43,14.43,3.11,13.97-2.66,13.97-2.66l5.01,7.12s-35.76,2.64-39.26,0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114.34 181.52 125.49 178.34 137.04 181.52 114.34 181.52"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    "data-name": "Layer 6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.79,42.15s8-8.77,15.06-11.14c9.53-3.2,16.09-4.88,23.31,0,0,0-9.84,7.95-7.85,10.66s3.88,1,10.59,1.52c5.51.43,12.7,5.88,12.7,5.88,0,0-10.9-1.08-14.07,2.53,0,0,6.58,2.35,6.4,6.14s-10.25,2.73-19.04,10.31-15.01,17.62-23.46,19.38c0,0,12.51-18.3,7.63-24.62s-15.9,1.28-15.9,1.28c0,0,9.25-12.36,17.65-16.81,12.69-6.73-6.66-9.07-13.01-5.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M193.07,90.78c-.81-4.43,9.93-4.42,6.44-16s-14.43-15.86-16.49-13.16,0,9.36,0,9.36l5.07,6.66s-.59,3.53-4.42,2.72-5.69-1.13-5.69-1.13c0,0,8.19,13.59,6.46,31.57,0,0,10.69-8.79,8.63-20.01h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184.78,147.17s10.98-18.58,10.98-21.76-2.13-8.92-2.13-8.92c0,0-4.37,13.76-4.96,18.01s-6.48,10.05-6.48,10.05l2.59,2.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M66.01,147.17s-11.28-15.84-11.28-19.02,2.43-11.66,2.43-11.66c0,0,4.37,13.76,4.96,18.01s6.48,10.05,6.48,10.05l-2.59,2.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M189.88,165.3s-16.27,9.08-14.92,22.03,20.33,26.44,17.98,44.46c-.58,4.45,4.21,4.45,7.42,1.74s18.54-17.01,15.23-25.32-13.56-15.08-12.21-26.67c0,0-1.13,12.37-7.91,7.54s-8.06-13.14-5.58-23.77h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.54,136.53c-7.53,6.6-7.7,3.37-10.99-6.66.69.38,2.7,10.44-4.93,19.84-3.77,4.63-.52,8.15,2.98,10.42,5.43,3.5,15.28,0,15.99-5.32s-10.43.91-3.05-18.28h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "180.3 169.05 187.64 166.73 176.51 176.41 182.82 185.53 170.87 179.22 180.3 169.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.45,145.29c7.53,6.6,5.9,1.88,7.53-9.39,0,0,1.56,8.95,5.56,15.99s2.24,14.42-1.35,14.54-5.57.64-6.27-4.68-.42-9.08-5.47-16.47h0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Mud"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M149.84,213.89s-2.9,5.35-6.12,4.38-11.13-7.31-14.26-4.38-3.29,8.08,2.18,12.91c5.47,4.83-.16,6.51,3.14,11.39s5.7,5.82,10.46,4.06,10.39-3.09,10.39-7.46-5.8-20.9-5.8-20.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M201.91,277.89s-2.68,8.62,2.27,12.04,10.66-1.02,11.39,2.73,2.55,4.39,3.24,6.95,10.66,5.69,7.93,13.06-20.62,17.66-20.62,22.1c0,3.88-4.2,9.87-7.23,12.5-.43.38-.27.05-.66.1-3.16.41,3.8-17.14,3.68-34.55s0-34.92,0-34.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M240.26,249.78s1.39,3.4-4.18,10.39-8.36,16.09-6.97,21.47,6.27,4.11,9.94,7.24c3.34,2.85,7.83,8.81,7.1,14.6s2.93-19.82,2.51-24.12-5.39-26.34-8.4-29.58h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1.53,284.15s4.27,7.62,10.03,8.96c5.76,1.34,3.25,8.52,4.76,9.02s12.7-1.5,9.86,9.02c-2.84,10.53-6.52,11.17-6.52,18.62s-1.5,26.33-6.68,32.01l-8.35-60.65-3.09-16.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M52.08,285.65s2.71-5.7,6.97-5.99,17.55,2.3,17.55-1.77-6.72-5.97-4.38-8.31,4.97,1.75,9.79,0,4.71-5.4,6.96-4.38,6.58,10.2,2.29,15.25-5.16,3.22-7.06,3.7-6.02,18.83-14.71,15.37c-11.75-4.67-17.4,2.63-17.4,2.63v-16.51h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.44,159.64c1.96-3.67,7.14,1.3,5.71,4.02s-6.49,7.07-6.49,11.65-2.24,10.42-2.24,10.42l-13.6-18.4s13.5-1.86,16.62-7.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M106.11,150.42s2.47-5.81,5.26-4.01,2.15,6.87,0,8.03-5.52.52-5.26-4.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.3,136.33c2.86-1.88,6.88-3.82,8.7-2.14s1.95,9.35-4.35,10.91-6.81-2.58-6.81-2.58l2.46-6.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M165.04,85.19c-2.82,2.63-9.14-2.35-11.33-1.03s4.85,5.07,5.23,9.2,13.34,10.71,16.25,10.71c0,0,.08-5.41-2.59-8.9s-7.55-9.97-7.55-9.97h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.58,80.98s-5.37,5.37-2.93,12.21,5.37,5.77,5.37,10.88,5.88,5.61,5.99-5.74-2.21-11.72-3.55-17.34-2.45-8.18-2.45-8.18l-2.43,8.18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M168.18,172.56c.81-4.68,6.85,2.82,8.02,6.84.91,3.13,2.87,3.39,4.62,4.23s-.33,16.15-6.08,19.72c-6.6,4.1-.1-13.71-6.15-23.61-1.26-2.06-1.04-3.53-.41-7.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M65.4,158.98s-3.56,7.8,1.37,14.56c3.48,4.78,4.58,3.4,4.58,8.73s9.56-4.3,6.19-11.65c-2.03-4.42-4.75-4.33-4.75-4.33l-7.38-7.32h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M252.18,198.11c-1.64-2.54-2.12-5.02-.22-4.33s2.88,2.62,2.58,4c-1.19,5.48-1.29,1.99-2.36.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M80.14,35c4.62,7.14,0,10.71,18.15,8.62,5.33-.61,13.72,1.4,15.69,1.04s5.55-6.45-1.62-12.73-11.47-6.45-11.47-6.45l-20.75,9.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M250.73,196.91s0,3.36-1.92,8.14,5.24,7.94,6.38,3.76c1.14-4.18-.75-12.47-.75-12.47l-3.71.57Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror_copy",
    "data-name": "Lines Mirror copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M172.59,115.51l-4.04,2.07s-10.51-4.31-15.71-4.05c-5.65.28-13.5,5.45-16.3,7.21,0,0,2.31-5.52,4.55-7.15,1.28-.93,7.99-4.09,7.99-4.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.81,123.1s-8,7.13-12.06,7.46-14.15-2.37-14.15-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M77.92,115.51l4.04,2.07s10.51-4.31,15.71-4.05c5.65.28,13.5,5.45,16.3,7.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.7,123.1s8,7.13,12.06,7.46,14.15-2.37,14.15-2.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.05,158.98s-1.21-.74-2.42-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.7,162.85s-3.95,9.17-7.25,12.91-29.43,27.3-32.99,27.96-2.84.69-4.31.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M193.99,116.49s2.34,5,2.08,8.48c-.26,3.48-2.55,11.04-5.89,15.22s-6.5,8.48-6.5,8.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.34,185.32s-1.91,19.09-1.65,24.82.64,11.64.67,18.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.97,92.23s5.79,4.88,4.49,11.38-8.06,14.04-6.24,19.89c1.82,5.85,27.8,12.7,15.07,41.97-10.06,23.14,16.48,2.93,26.58,8.82,20.91,12.19,9.1,32.52,9.1,32.52,0,0-5.47-35.03-26.95-10.99-7.81,8.75,17.41,18.08,12.31,37.52-1.86,7.1-5.32,25.33-27.11,26.83,0,0,7.62-10.01,4.35-19.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M215.58,240.59s-1.71,13.25-12.18,18.59-27.56,4.27-35.89-3.63c0,0,12.61-1.28,14.96-8.97s.64-20.72-1.71-26.49c0,0,2.81,9.61-2.36,16.08-3.78,4.73-8.32,6.89-16.44,5.13,0,0,8.55-1.61,7.91-6.92s-16.4-11.72-18.35-20.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183.32,242.25s-27.19,6.97-35.45,8.18-13.08,6.89-13.08,6.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M152.34,219.92s4.44,8.11,3.21,15.45-10,32.89-30.4,46.44c0,0,5.05,7.03,4.95,8.45-.21,2.77-3.04,5.47-4.95,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.15,319.42c24.56-.87,64.17-21,64.17-21l8.23,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.01,262.49s2.12,20.91,3.27,35.93h5.98s-2.3-30.21-3.75-35.93h-5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.64,236.94s.52,6.68,1.02,12.84l1.36-9.09-.77-11.19-1.61,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M134.27,295.65s-4.72,4.33-6.54,7.25c-2.57,4.13-2.57,15.52-2.57,15.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.07,110.42s1.09,8.82,6.65,14.54c5.56,5.72,5.76,14.7,4.13,17.56s-2.33,7.87,4.26,11.01,12.85-4.53,16.85-14.21c3.06,4.94,1.69,20.09-8.17,24.72-10.23,4.8-29.31,6.96-31.24-12.06-.63-6.23,9.52-9.45,6.46-18.43-3.06-8.98-11.89-11.97-14.5-21.13s-1.74-6.89-1.74-6.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128.25,158.98s1.21-.74,2.42-.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M83.49,168.52c1.65,3.18,3.25,5.98,4.36,7.24,3.3,3.74,29.43,27.3,32.99,27.96s2.84.69,4.31.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M56.31,116.49s-2.34,5-2.08,8.48c.26,3.48,2.55,11.04,5.89,15.22s5.49,6.23,5.49,6.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.96,185.32s1.91,19.09,1.65,24.82-.64,11.64-.67,18.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M42.32,96.33s-1.77.78-.47,7.28,8.06,14.04,6.24,19.89c-1.82,5.85-30.7,14.14-15.07,41.97s-1.74,33.17-12.47,31.15c-14.14-2.66-4.45-18.92-4.45-18.92-7.98-.89-32.59,34.02,11.24,33.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M15.5,211.55s-5.46,14.7-3.54,21.78,5.32,25.33,27.11,26.83c0,0-7.62-10.01-4.35-19.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.73,240.59s1.71,13.25,12.18,18.59,27.56,4.27,35.89-3.63c0,0-12.61-1.28-14.96-8.97s-.64-20.72,1.71-26.49c0,0-2.81,9.61,2.36,16.08,3.78,4.73,8.32,6.89,16.44,5.13,0,0-8.55-1.61-7.91-6.92s16.4-11.72,18.35-20.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.98,242.25s27.19,6.97,35.45,8.18,13.08,6.89,13.08,6.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.96,219.92s-4.44,8.11-3.21,15.45,10,32.89,30.4,46.44c0,0-5.05,7.03-4.95,8.45.21,2.77,3.04,5.47,4.95,5.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.35,245.82s-6.28,3.27-7.72,6.15-5.5,23.94-5.1,32.19,10.03,73.33,17.07,125.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M45.11,272.35s4.33,6.66,4.9,9.27c1.92,8.83.19,27.29,1.53,44.04,1.1,13.83,7.51,61.53,7.51,61.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.96,245.82s6.28,3.27,7.72,6.15,5.5,23.94,5.1,32.19-10.03,73.33-17.07,125.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M205.2,272.35s-4.33,6.66-4.9,9.27c-1.92,8.83-.19,27.29-1.53,44.04-1.1,13.83-7.51,61.53-7.51,61.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.15,319.42c-24.56-.87-64.17-21-64.17-21l-8.23,4.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.29,262.49s-2.12,20.91-3.27,35.93h-5.98s2.3-30.21,3.75-35.93c0,0,5.5,0,5.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.67,236.94s-.52,6.68-1.02,12.84l-1.36-9.09.77-11.19,1.61,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M116.04,295.65s4.72,4.33,6.54,7.25c2.57,4.13,2.57,15.52,2.57,15.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M95.34,44.05s-26.61,21.18-31.72,28.55-6.39,15.14-6.39,15.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M124.31,39.89s11.72-2.84,21.74,2.84,15.5,14.56,17.39,25.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.47,105.58c-3.63,3.43-13.51,3.12-17.73,3.78-19.83,3.09-60.69-9.75-34.6-58.53,0,0-4.91,34.98,13.89,37.2,17.25,2.03,26.89-12.97,26.89-12.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.15,76.19s3.73-2.7,13.34-2.26c11.12.5,16.26,6.43,16.26,6.43,0,0-.16-14.89-14.15-14.89s-14.83,7.5-17.15,11.47c0,0-5.6,10.14-7.84,17.98-1.95,6.84-.48,21.93,9.54,26.72.43.21.89.41,1.37.59,11.51,4.46-12.49.86-20.86-7.65s-13.55-15.79-6.06-31.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M154.75,80.35c4.85-2.38,10.82,3.39,17.11,11.88,7.52,10.15,6.27,24.26.72,32.73-4.37,6.67-9.97,11.19-9.49,19.76,0,0-3.21,8.98-9.4,5.04s-11.06-11.25-11.06-11.25c0,0-1.03,31.54,24.17,20.18,4.92-2.22,2.57,8.07.99,11.24-3.27,6.53,4.45,18.13,18.45,15.39,0,0-15.36-7.63-2.71-13.69,6.64-3.18,5.33-11.15,3.29-17.07-2.04-5.92-9.6-12.05-6.53-21.03,3.06-8.98,11.64-12.05,14.5-21.13s-1.85-30.66-9.83-38.51c-7.98-7.84-17.75-3.53-17.75-3.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M146.33,23.22c-16.25-3.94-37.21-3.15-60.61,8.43s-34.33,47.02-35.47,50.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.45,41.68c4.43,3.76,6.18,18.29,6.18,18.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M203.94,92.23c-1.97-9.11,1.72-21.67-2.96-29.8s-23.11-9.18-23.15-14.04c-.09-11.71-22.45-16.36-13.39-35.36,4.46-9.34,18.66.4,18.66.4-7.79-19.33-25.92-10.98-31.35-4.06-6.3,8.01-2.78,18.1-2.78,18.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.79,95.16c-1.13,1.77-.07,6.93,7.57,7.36s21.89.93,28.02,3.54c0,0-18.1-5.17-27.52-6.31-4.79-.58-8.07-4.59-8.07-4.59h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M125.15,181.99c-2.72-.11-16.45,2.76-19.63-1.33-2.23-2.88,4.15-8.77,7.55-10.19s10.21.25,12.08.25,8.68-1.67,12.08-.25,9.78,7.32,7.55,10.19c-3.18,4.1-16.91,1.22-19.63,1.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110.81,171.77s3.94,3.5,14.35,3.54,14.02-3.54,14.02-3.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111.37,181.52s6.05-4.06,13.78-3.82c7.73.24,12.81,3.82,12.81,3.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.91,122.21c.5-3.02,2.39-3.4,4.25-3.69s4.29,1.5,4.24,3.69-1.27,4.03-3.93,4.03c-3.78,0-4.82-2.47-4.56-4.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.77,122.21c.5-3.02,2.39-3.4,4.25-3.69s4.29,1.5,4.24,3.69-1.27,4.03-3.93,4.03c-3.78,0-4.82-2.47-4.56-4.03h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJasminetrip);
export default __webpack_public_path__ + "static/media/jasmine trip.5ac34514c563b18ae50792ec34575c36.svg";
export { ForwardRef as ReactComponent };